import React from "react";

export const Skills = () => {
  return <div>Soft Skills Technical Skills Skills</div>;
};

export default Skills;
